export const profileStats = {
  subscriptionPlan: 'Free' as 'Free' | 'Premium' | 'Premium+' | 'Premium Yearly' | 'Premium+ Yearly',
};

/* ── AI Preferences ── */
// NOTE: actual runtime state lives in AIPreferencesContext (localStorage backed)
// These are the canonical option definitions used by UI components

export const explanationStyles = [
  { id: 'Simple', label: 'Simple', description: 'Shorter explanations with faster summaries' },
  { id: 'Detailed', label: 'Detailed', description: 'Deeper breakdowns with more reasoning and examples' },
  { id: 'Exam Style', label: 'Exam Style', description: 'Concise, exam-focused with marking guidance' },
  { id: 'Step-by-Step', label: 'Step-by-Step', description: 'Numbered structure with detailed calculations' },
  { id: 'Beginner Friendly', label: 'Beginner Friendly', description: 'Foundational concepts with analogies' },
] as const;

export const voiceStyles = [
  { id: 'Calm', label: 'Calm', description: 'Relaxed and soothing narration' },
  { id: 'Professional', label: 'Professional', description: 'Formal, clear, and authoritative' },
  { id: 'Energetic', label: 'Energetic', description: 'Upbeat, encouraging, and dynamic' },
  { id: 'Tutor Style', label: 'Tutor Style', description: 'Personal, patient one-on-one feel' },
  { id: 'Student Friendly', label: 'Student Friendly', description: 'Casual, relatable study buddy' },
] as const;

export const narrationSpeeds = [
  { id: 'Slow', label: 'Slow', value: 0.75 },
  { id: 'Normal', label: 'Normal', value: 1 },
  { id: 'Fast', label: 'Fast', value: 1.25 },
] as const;

export const learningModes = [
  { id: 'Homework Help', label: 'Homework Help', icon: 'ri-book-line', description: 'Focus on solving specific problems step-by-step' },
  { id: 'Exam Revision', label: 'Exam Revision', icon: 'ri-graduation-cap-line', description: 'Concise revision notes and exam-focused summaries' },
  { id: 'Learn New Topic', label: 'Learn New Topic', icon: 'ri-lightbulb-line', description: 'Complete introduction with foundations and examples' },
  { id: 'Quick Summary', label: 'Quick Summary', icon: 'ri-flashlight-line', description: 'Fast overviews of key concepts only' },
  { id: 'Deep Study', label: 'Deep Study', icon: 'ri-brain-line', description: 'Thorough explanations with connections and depth' },
] as const;

export const appearanceOptions = [
  { id: 'light', label: 'Light', icon: 'ri-sun-line' },
  { id: 'dark', label: 'Dark', icon: 'ri-moon-line' },
  { id: 'system', label: 'System Default', icon: 'ri-smartphone-line' },
];

export const allSubjects = [
  'Calculus II',
  'Organic Chemistry',
  'Physics: Mechanics',
  'Linear Algebra',
  'World History',
  'Biology',
  'English Literature',
  'Computer Science',
  'Statistics',
  'Economics',
  'Philosophy',
  'Psychology',
];

/* ── Subscription Plans ── */
export const subscriptionPlans = [
  {
    id: 'free',
    name: 'Free',
    monthlyPrice: 0,
    displayPrice: 'R0',
    description: 'All core LAVYN study tools',
    billing: 'monthly' as const,
    features: [
      '4 AI teaching videos per month',
      'Standard AI lessons',
      'Ads during video generation',
      'All core LAVYN study tools',
    ],
    active: true,
    recommended: false,
    accentColor: 'neutral' as const,
    savePercent: null,
    badge: null,
  },
  {
    id: 'premium',
    name: 'LAVYN Premium',
    monthlyPrice: 89.99,
    displayPrice: 'R89.99',
    description: 'Longer and deeper AI lessons when the topic requires it',
    billing: 'monthly' as const,
    features: [
      '12 AI teaching videos per month',
      'Longer and deeper AI lessons when the topic requires it',
      'No ads during video generation',
      'All LAVYN study tools included',
    ],
    active: false,
    recommended: false,
    accentColor: 'neutral' as const,
    savePercent: null,
    badge: null,
  },
];